import _, { get } from 'lodash';
import React from 'react';
import {
  OddsFormat,
  BetType,
  RoundRobinOption,
  WinRiskType,
  SelectionType,
  SimplifiedBetType,
  SimplifiedOriginalBetType,
  SimplifiedSelectionType,
  BROWSER_KEY
} from '../../common/Foundation';
import Constants from '../../common/Constants';
import betPlacementService from '../../services/BetPlacementService';
import uuid from 'uuid/v1';
import Utils from '../../common/Utils';
import ToastGeneratorAction from '../BaseComponent/ToastGeneratorComponent/ToastGeneratorAction';
import PopUpModalAction from '../BaseComponent/PopUpModalComponent/PopUpModalAction';
import { Base64 } from 'js-base64'
import StorageHelper from '../../common/StorageHelper';

export default class BetslipAction {

  static THOUSANDS_SEPARATOR = ',';

  static getMaxpayout(stake, odds, oddType, betType, winRiskOption) {
    if (!stake || stake === 0) {
      return 0;
    }
    stake += ''
    stake = Number(stake.replaceAll(this.THOUSANDS_SEPARATOR, ''));
    odds = Number(odds);
    let payout = 0;
    let factor = Number(oddType) === OddsFormat.American ? 100 : 1;
    if (OddsFormat.American === Number(oddType)) {
      if (winRiskOption === 'WIN') {
        if (odds > 0) {
          payout = stake + (stake / odds * 100);
        } else if (odds < 0) {
          payout = stake + (stake * Math.abs(odds) / 100);
        }
      } else if (winRiskOption === 'RISK') {
        if (odds > 0) {
          payout = stake + (stake * odds / 100);
        } else if (odds < 0) {
          payout = stake + (stake / Math.abs(odds) * 100);
        }
      } else {
        payout = (Math.abs(odds) / 100 + 1) * stake;
      }
    } else if (OddsFormat.Decimal === Number(oddType)) {
      payout = this.calculateToWin(stake, odds, oddType, winRiskOption)
        + this.calculateToRisk(stake, odds, oddType, winRiskOption);
    } else {
      if (BetType.THE_1X2 !== betType) {
        if (odds < 0) {
          let isTrue = OddsFormat.Malay === Number(oddType) || OddsFormat.Indonesian === Number(oddType);
          payout = isTrue ? (stake * Math.abs(odds) + stake) : stake * 2;
        } else if (odds < 1) {
          payout = stake * odds + stake;
        } else {
          if (Number(oddType) === OddsFormat.Decimal) {
            payout = stake * odds;
          } else {
            payout = stake * (odds / factor) + stake;
          }
        }
      } else {
        payout = stake * Math.abs(odds);
      }
    }
    return Number(payout);
  }

  static formatNumberWithGivenDecimalPlace(number, digits) {
    let strNum = number + ''
    let idx = strNum.indexOf('.')
    return strNum.substring(0, idx + digits + 1)
  }

  static calculateTeaserWinRiskInfo(stake, odds, oddsFormat, winRiskOption){
    let winriskInfo = { toWin: 0, toRisk: 0, maxPayout: 0}

    if (!stake || stake === 0) {
      return winriskInfo
    }
    let oddsValue = parseFloat(odds);
    let convertedStake = BetslipAction.convertStakeToNumber(stake);
    winriskInfo.maxPayout = this.calculateTeaserMaxPayout(stake, odds, oddsFormat, winRiskOption);
    if (OddsFormat.American === oddsFormat) {
      switch (winRiskOption){
          case 'WIN': 
              winriskInfo.toWin = convertedStake;
              winriskInfo.toRisk = BetslipAction.calculateToRiskFromWin(convertedStake, oddsValue, oddsFormat);        
              break;
          case 'RISK': 
              winriskInfo.toRisk = convertedStake;
              winriskInfo.toWin = BetslipAction.calculateToWinFromRisk(convertedStake, oddsValue, oddsFormat);
              break;
          default: BetslipAction.calculateNormalOdds (convertedStake, oddsValue, oddsFormat, winriskInfo);
              
      }
    } else {
      BetslipAction.calculateNormalOdds(convertedStake, oddsValue, oddsFormat, winriskInfo);
    }
    return winriskInfo;
  }

  static calculateNormalOdds (stake, odds, oddsFormat, winriskInfo){
    let isOddsNegative = odds < 0;
    switch (isOddsNegative){
        case true :
          winriskInfo.toWin = stake;
          winriskInfo.toRisk = BetslipAction.calculateToRiskFromWin(stake, odds, oddsFormat);
          break;
        default :
        winriskInfo.toRisk = stake;
        winriskInfo.toWin = BetslipAction.calculateToWinFromRisk(stake, odds, oddsFormat);
    }
  }

  /**
     * Calculate Parlay with Round Robin Max payout
     */
  static calculateParlayWithRROMaxPayout(stake, availableRROs, selectedRROs) {
    let winriskInfo = { toWin: 0, totalStake: 0, maxPayout: 0 }

    if (!stake || stake === 0) {
      return winriskInfo
    }

    let convertedStake = BetslipAction.convertStakeToNumber(stake)

    // Loop through the available RROs and calculate
    _.map(availableRROs, roundRobin => {
      if (selectedRROs.indexOf(roundRobin.roundRobinOption) > -1) {
        winriskInfo = this.calculateParlayPayoutByRRO(winriskInfo, roundRobin, convertedStake)
      }
    })

    return winriskInfo
  }

  /**
   * calulate to win and max payout base on unround decimal odds
   * @param {*} winriskInfo 
   * @param {*} roundRobin 
   */
  static calculateParlayPayoutByRRO(winriskInfo, roundRobin, stake) {
      let roundRobinOdds

      if (RoundRobinOption.PARLAY === roundRobin.roundRobinOption) {

        roundRobinOdds = roundRobin.unroundedDecimalOdds
        totalToWin = stake * (roundRobinOdds - 1)
      } else {
        roundRobinOdds = roundRobin.unroundedDecimalOdds
      }

      let totalToWin = stake * (roundRobinOdds - 1)
      let totalStake = stake * roundRobin.possibleWagers;

      winriskInfo.toWin += totalToWin;
      winriskInfo.totalStake += totalStake;
      winriskInfo.maxPayout += totalToWin + totalStake;
    
      return winriskInfo;
  }

  static calculateParlayOdds(legs, oddsFormat, isDecBase) {
    let parlayOdds = 1

    _.map(legs, leg => {
      if (BetType.THE_1X2 == leg.betType && OddsFormat.AM != oddsFormat) {
        parlayOdds *= Number(leg.odds)
      } else {
        parlayOdds *= this.formatOddsToDec(leg.odds, oddsFormat)
      }
    })

    parlayOdds = isDecBase ? parlayOdds : this.fromDecToTargetOdds(parlayOdds, oddsFormat)
    return parlayOdds
  }

  static calculatePayout(parlayOdds, stake, oddsType) {
    if (!stake) {
      return 0;
    }
    return this.calculateToWin(stake, parlayOdds, oddsType) + parseFloat(stake);
  }

  /**
    * calculate Win from stake
    * @param {*} stake 
    * @param {*} odds 
    * @param {*} ot : odds type
    * @param {*} wrs : win risk stake (WIN, RISK, BASE)
    */
  static calculateToWin(stake, odds, ot, wrs) {
    let win = 0;
    if (ot === OddsFormat.Malay) {
      wrs = parseFloat(odds) > 0 ? Constants.WIN_RISK_OPTION.RISK : Constants.WIN_RISK_OPTION.WIN
    }
    if (wrs === 'WIN') {
      win = stake;
    } else if (wrs === 'RISK') {
      win = this.calculateToWinFromRisk(stake, odds, ot);
    } else {
      if (odds > 0) {
        win = this.calculateToWinFromRisk(stake, odds, ot);
      } else {
        win = stake;
      }
    }
    return parseFloat(win);
  }

  /**
   * calculate Risk from stake
   * @param {*} stake 
   * @param {*} odds 
   * @param {*} ot : odds type
   * @param {*} wrs : win risk stake (WIN, RISK, BASE)
   */
  static calculateToRisk(stake, odds, ot, wrs) {
    let risk = 0;
    if (ot === OddsFormat.Malay) {
      wrs = parseFloat(odds) > 0 ? Constants.WIN_RISK_OPTION.RISK : Constants.WIN_RISK_OPTION.WIN
    }
    if (wrs === 'WIN') {
      risk = this.calculateToRiskFromWin(stake, odds, ot);
    } else if (wrs === 'RISK') {
      risk = stake;
    } else {
      if (odds > 0) {
        risk = stake;
      } else {
        risk = this.calculateToRiskFromWin(stake, odds, ot);
      }
    }
    return parseFloat(risk);
  }

  /**
     * Calculate Win from Risk
     * @param {*} riskAmount 
     * @param {*} odds 
     * @param {*} ot : odds type
     */
  static calculateToWinFromRisk(riskAmount, odds, ot) {
    let win = 0;
    switch (Number(ot)) {
      case OddsFormat.American:
        if (odds === 0) {
          win = 0;
        } else if (odds > 0) {
          win = (riskAmount / 100) * odds;
        } else if (odds < 0) {
          win = (riskAmount / Math.abs(odds)) * 100;
        }
        break;
      case OddsFormat.Decimal:
        win = riskAmount * (odds - 1);
        break;
      case OddsFormat.HongKong:
        win = riskAmount * odds;
        break;
      case OddsFormat.Indonesian:
        win = odds === 0 ? 0 : odds > 0 ?
          riskAmount * odds : riskAmount / Math.abs(odds);
        break;
      case OddsFormat.Malay:
        win = odds === 0 ? 0 : odds > 0 ?
          riskAmount * odds : riskAmount / Math.abs(odds);
        break;
      default: win = 0;
    }
    return win;
  }

  /**
   * Calculate Risk from Win
   * @param {*} winAmount 
   * @param {*} odds 
   * @param {*} ot : odds type
   */
  static calculateToRiskFromWin(winAmount, odds, ot) {
    let risk = 0;
    switch (Number(ot)) {
      case OddsFormat.American:
        if (odds === 0) {
          risk = 0;
        } else if (odds > 0) {
          risk = (winAmount / odds) * 100;
        } else if (odds < 0) {
          risk = (winAmount / 100) * Math.abs(odds);
        }
        break;
      case OddsFormat.Decimal:
        risk = winAmount / (odds - 1);
        break;
      case OddsFormat.HongKong:
        risk = winAmount / odds;
        break;
      case OddsFormat.Indonesian:
        risk = odds === 0 ? 0 : odds > 0 ?
          winAmount / odds : winAmount * Math.abs(odds);
        break;
      case OddsFormat.Malay:
        risk = odds === 0 ? 0 : odds > 0 ?
          winAmount / odds : winAmount * Math.abs(odds);
        break;
      default: risk = 0;
    }
    return risk;
  }

  static generateUUID() {
    function generate() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return generate() + generate() + '-' + generate() + '-' + generate() + '-' +
      generate() + '-' + generate() + generate() + generate();
  };


  static convertStakeToNumber(stake) {
    if (stake) {
      stake = stake.toString().split(',').join('');
    }
    return !isNaN(stake) ? Number(stake) : stake;
  }


  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
  }

  static validateAsiaSingleBetItem(winRiskOption, selection, stake) {
    const { maxStakeWin, maxStakeRisk, maxStakeBase, minStakeWin, minStakeRisk, minStakeBase, odds } = selection

    const minStake = this.getStakeLimit(winRiskOption, minStakeWin, minStakeRisk, minStakeBase, odds)
    const maxStake = this.getStakeLimit(winRiskOption, maxStakeWin, maxStakeRisk, maxStakeBase, odds)
    const convertedStake = this.convertStakeToNumber(stake)
    let validationMessage = convertedStake < minStake ? Constants.INVALID_MIN_STAKE : 
      (convertedStake > maxStake ? Constants.INVALID_MAX_STAKE : "");
    if (selection.maxStake === 0 || maxStake === 0) {
      validationMessage = Constants.MAX_ZERO_MESSAGE;
    } else if (!convertedStake) {
      validationMessage = Constants.INVALID_STAKE;
    }

    return {
      errorCode: validationMessage,
      minStake: minStake,
      maxStake: maxStake
    }
  }

  static validateAsiaParlayBetItem(parlayTicket, stake, maxRoundRobinRiskStake) {
    const minStake = parlayTicket.minRiskStake
    const convertedStake = this.convertStakeToNumber(stake)
    let validationMessage = convertedStake < minStake ? Constants.INVALID_MIN_STAKE : 
      (convertedStake > maxRoundRobinRiskStake ? Constants.INVALID_MAX_STAKE : "");

    if (!convertedStake) {
      validationMessage = Constants.INVALID_STAKE;
    }

    return {
      errorCode: validationMessage,
      minStake: minStake,
      maxStake: maxRoundRobinRiskStake
    }
  }

  static validateAsiaTeaserBetItem(teaserTicket, winRiskOption, stake) {
    const convertedStake = this.convertStakeToNumber(stake)
    let validationMessage = ''
    const {
      odds,
      maxRiskStake,
      maxWinStake,
      minRiskStake,
      minWinStake
    } = teaserTicket;
    const minRisk = BetslipAction.getMinRiskForTeaser(winRiskOption, minRiskStake, minWinStake, odds);
    const maxRisk = BetslipAction.getMaxRiskForTeaser(winRiskOption, maxRiskStake, maxWinStake, odds);

    if (convertedStake < minRisk || convertedStake > maxRisk) {
      if (convertedStake < minRisk) {
        validationMessage = Constants.INVALID_MIN_STAKE;
      } else if (convertedStake > maxRisk) {
        validationMessage = Constants.INVALID_MAX_STAKE;
      }
    }
    return {
      errorCode: validationMessage,
      minStake: minRisk,
      maxStake: maxRisk
    }
  }

  static validateNormalBetItems(oddsFormat, winRiskOption, normalBetItems) {
    let validationMessage = '';
    let invalidOddsId = [];
    _.forEach(normalBetItems, (item, index) => {
      if (!item.wagerId &&
        (
          !item.errorCode 
          || item.errorCode === Constants.LINE_CHANGED 
          || item.errorCode === Constants.MAX_BET_EXCEEDED 
          || item.errorCode === Constants.CORRELATED
        ) &&
        item.status !== Constants.UNAVAILABLE) {
        const stake = this.convertStakeToNumber(document.getElementById(item.oddsId.toString()).value);
        const minStake = this.getMinWinRiskByOddFormat(oddsFormat, winRiskOption, item);
        const maxStake = this.getMaxWinRiskByOddFormat(oddsFormat, winRiskOption, item);

        if (item.maxStake === 0 || maxStake === 0) {
          validationMessage = Constants.MAX_ZERO_MESSAGE;

        } else if (!stake || stake < minStake) {
          validationMessage = Constants.INVALID_MIN_STAKE;
          invalidOddsId.push(item.oddsId);

        } else if (stake > maxStake) {
          validationMessage = Constants.INVALID_MAX_STAKE;
          invalidOddsId.push(item.oddsId);
        }
      }
    })
    return {
      message: validationMessage,
      invalidOddsId: invalidOddsId
    };
  }

  static getMinWinRiskByOddFormat(oddsFormat, winRiskOption, selection) {
    let minLimit
    if (Number(oddsFormat) === OddsFormat.AM || Number(oddsFormat) === OddsFormat.EU) {
      switch (winRiskOption) {
        case Constants.WIN_RISK_OPTION.RISK:
          minLimit = selection.minStakeRisk
          break;

        case Constants.WIN_RISK_OPTION.WIN:
          minLimit = selection.minStakeWin
          break;

        case Constants.WIN_RISK_OPTION.BASE:
          minLimit = selection.minStakeBase
          break;

        default:
      }
    } else {
      minLimit = selection.minStake
    }

    return minLimit
  }

  static getMaxWinRiskByOddFormat(oddsFormat, winRiskOption, selection) {
    let maxLimit
    if (Number(oddsFormat) === OddsFormat.AM || Number(oddsFormat) === OddsFormat.EU) {
      switch (winRiskOption) {
        case Constants.WIN_RISK_OPTION.RISK:
          maxLimit = selection.maxStakeRisk
          break;

        case Constants.WIN_RISK_OPTION.WIN:
          maxLimit = selection.maxStakeWin
          break;

        case Constants.WIN_RISK_OPTION.BASE:
          maxLimit = selection.maxStakeBase
          break;

        default:
      }
    } else {
      maxLimit = selection.maxStake;
    }

    return maxLimit
  }

  static getStakeLimit(winRiskType, winLimit, riskLimit, baseLimit, odds) {
    let limitVal
    switch (winRiskType) {
      case WinRiskType.BASE:
        limitVal = baseLimit
        break

      case WinRiskType.RISK:
        limitVal = riskLimit
        break

      case WinRiskType.WIN:
        limitVal = winLimit
        break

      default:
        if (odds < 0) {
          limitVal = winLimit
        } else {
          limitVal = riskLimit
        }
    }

    return limitVal
  }

  /**
   * To check the status of bet selection
   * @param {*} status 
   */
  static isInValidStatus (status) {
    switch(status){
      case Constants.UNAVAILABLE:
      case Constants.INVALID_BET_ACCEPTANCE_TYPE:
      case Constants.EVENT_OFFLINE:
      case Constants.OFFLINE_EVENT:
      case Constants.LINE_IS_NOT_AVAILABLE:
      case Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT:
      case Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED:
        return true;
      default: return false;
    }
  }
  static getKeyMessage (status) {
    switch(status){
        case Constants.UNAVAILABLE:
            return Constants.UNAVAILABLE_MESSAGE;
        case Constants.INVALID_BET_ACCEPTANCE_TYPE:
          return Constants.INVALID_BET_ACCEPTANCE_TYPE;
        default: return '';
    }
  }

  static isDisablePlaceBetBtn(betItems) {
    let isDisable = false;
    _.forEach(betItems, (item, index) => {
      if ((item.errorCode && 
        item.errorCode !== Constants.LINE_CHANGED && 
        item.errorCode !== Constants.MAX_BET_EXCEEDED) || 
        this.isInValidStatus(item.status) || 
        this.isInValidStatus(item.legStatus)) {
        isDisable = true;
      }
    })
    return isDisable;
  }

  static isDisableSinglePlaceBetBtn(betItems) {
    let isDisable = false;
    _.forEach(betItems, (item) => {
      if ((item.errorCode && 
        item.errorCode !== Constants.LINE_CHANGED && 
        item.errorCode !== Constants.CORRELATED && 
        item.errorCode !== Constants.MAX_BET_EXCEEDED) || 
        this.isInValidStatus(item.status) || 
        this.isInValidStatus(item.legStatus)) {
        isDisable = true;
      }
    })
    return isDisable;
  }

  static isDisableTeaserPlaceBetBtn(teaserBets) {
    const {
      legs,
      minLegs,
      maxLegs,
      status
    } = teaserBets;
    const isUnavailable = status === Constants.TEASER_ERROR.UNAVAILABLE;
    if (legs) {
      const isUnderOverLegs = legs.length < minLegs || legs.length > maxLegs
      let errorCode = false;
      _.forEach(teaserBets.legs, (leg, index) => {
        if (leg.errorCode && leg.errorCode !== Constants.TEASER_ERROR.SELECTION_POINT_CHANGED) {
          errorCode = true;
          return;
        }
      })
      return isUnavailable || isUnderOverLegs || errorCode;
    }
    return isUnavailable;
  }

  /**
   * Auto adjust stake to maxStake or minStake if input is invalid
   * @param {*} selections 
   * @param {*} oddsFormat 
   * @param {*} winRiskOption 
   * @param {*} validation 
   */
  static autoAdjustStake(selections, oddsFormat, winRiskOption, validation) {
    _.forEach(selections, (selection, index) => {
      const stakeInput = document.getElementById(selection.oddsId.toString());
      if (validation.message === Constants.INVALID_MIN_STAKE && validation.invalidOddsId.indexOf(selection.oddsId) > -1) {
        const minStake = this.getMinWinRiskByOddFormat(oddsFormat, winRiskOption, selection);
        Utils.triggerOnchangeInput(stakeInput, minStake);
      }
      if (validation.message === Constants.INVALID_MAX_STAKE && validation.invalidOddsId.indexOf(selection.oddsId) > -1) {
        const maxStake = this.getMaxWinRiskByOddFormat(oddsFormat, winRiskOption, selection);
        Utils.triggerOnchangeInput(stakeInput, maxStake);
      }
    })
  }

  /**
   * Get odds information when click on single tab
   * @param {*} oddsSelections 
   */
  static buildNormalBetSelectionPayload(oddsSelections, oddsFormat) {
    const normalOddsSelection = oddsSelections.reduce((filtered, selection) => {
      if (selection.oddsSelectionsType !== Constants.WAGER_TYPE.TEASERS) {
        filtered.push({
          oddsFormat: oddsFormat,
          oddsId: selection.oddsId,
          oddsSelectionsType: selection.oddsSelectionsType,
          selectionId: selection.selectionId,
        })
      }
      return filtered;
      }, []);
      return {
          oddsSelections: normalOddsSelection
        }
    }

 static buildTeaserBetSelectionPayload(oddsSelections, oddsFormat) {
   const teaserOddsSelection = oddsSelections.reduce((filtered, selection) => {
       filtered.push({
         oddsFormat: oddsFormat,
         oddsId: selection.oddsId,
         oddsSelectionsType: selection.oddsSelectionsType,
         selectionId: selection.selectionId,
       })
     return filtered;
     }, []);
     return {
         oddsSelections: teaserOddsSelection
       }
   }

  static isAllowParlay(selection) {
    return selection.parlayRestriction !== Constants.SUPPORT_PARLAY.NOT_ALLOWED
        && selection.oddsSelectionsType !== Constants.WAGER_TYPE.OUTRIGHT
        && selection.allowParlay;
  }
  /**
   * Get odds information when click on parlay tab
   * @param {*} oddsSelections 
   */
  static buildParlayBetSelectionPayload(oddsSelections, oddsFormat) {
    let parlayOddsSelections = [];
    _.forEach(oddsSelections, selection => {
      if (this.isAllowParlay(selection)) {
        parlayOddsSelections.push({
          legId: uuid(),
          oddsId: selection.oddsId,
          selectionId: selection.selectionId
        })
      }
    })

    return {
      parlayOddsRequest: {
        oddsFormat: oddsFormat,
        parlayOddsSelections: parlayOddsSelections,
        ticketId: uuid()
      }
    }
  }

  /**
   * Build payload to get teaser odds information when click on teaser tab
   * @param {*} oddSelections 
   * @param {*} oddsFormat 
   */
  static buildTeaserBetTicketParams(oddSelections, oddsFormat) {
    let legs = [];
    _.forEach(oddSelections, selection => {
        legs.push({
          legId: uuid(),
          selectionId: selection.selectionId
        })
    })
    return {
      teaserId: oddSelections[0].teaserId,
      ticketId: uuid(),
      oddsFormat: oddsFormat,
      legs: JSON.stringify(legs)
    }
  }


  /**
   * Prepare payload for place normal bet 
   * @param {*} normalBetItems 
   * @param {*} oddFormat 
   */
  static preparePayloadNormalBets(normalBetItems, oddFormat, winRiskOption) {
    const acceptBetterOdds = document.getElementById("accept-better-lines").checked;

    let selections = [];
    _.forEach(normalBetItems, (item, index) => {
      const stake = document.getElementById(item.oddsId.toString()).value;
      const selection = {
        odds: item.odds,
        oddsId: item.oddsId,
        selectionId: item.selectionId,
        stake: this.convertStakeToNumber(stake),
        uniqueRequestId: this.generateUUID(),
        wagerType: item.oddsSelectionsType,
        betLocationTracking: item.betLocationTracking
      }
      if (Number(oddFormat) === OddsFormat.AM || Number(oddFormat) === OddsFormat.EU) {
        selection.winRiskStake = winRiskOption;
      }
      if (item.sportId === Constants.BASEBALL_ID && item.betType === BetType.THE_1X2 && item.baseBall) {
        const itemOnUI = document.querySelector(".single-bet-item[selection='" + item.selectionId + "']");
        const pitcherTeam1Input = itemOnUI.querySelector(".pitcher-team1 input[type='checkbox']");
        const pitcherTeam2Input = itemOnUI.querySelector(".pitcher-team2 input[type='checkbox']");

        if (pitcherTeam1Input && pitcherTeam1Input.checked) {
          selection[pitcherTeam1Input.getAttribute('name')] = pitcherTeam1Input.checked;
        }
        if (pitcherTeam2Input && pitcherTeam2Input.checked) {
          selection[pitcherTeam2Input.getAttribute('name')] = pitcherTeam2Input.checked;
        }
      }
      selections.push(selection);
    })
    return {
      acceptBetterOdds: acceptBetterOdds,
      oddsFormat: oddFormat,
      selections: selections
    }
  }

  /**
   * * Prepare payload for place parlay bet 
   * @param {*} parlayBetItems 
   * @param {*} oddFormat 
   * @param {*} selectedRoundRobins
   */
  static preparePayloadParlayBets(parlayBetItems, oddFormat, selectedRoundRobins, betslipStore) {
    const { ticketId, legs } = parlayBetItems;
    const acceptBetterOdds = document.getElementById("parlay-accept-better-lines").checked;
    const stake = this.convertStakeToNumber(document.querySelector('.stake-row input.stake').value);
    betslipStore.updateInitStakeReuse(stake);
    return {
      oddsFormat: oddFormat,
      acceptBetterOdds: acceptBetterOdds,
      roundRobinOptions: selectedRoundRobins,
      stake: stake,
      ticketId: ticketId,
      uniqueRequestId: uuid(),
      betLocationTracking: get(legs, `[${legs.length - 1}].betLocationTracking`)
    }
  }


  /**
   * For render accepted bet screen, we need some information from bet selection such as: league name, sport name, bet type
   * @param {*} selections 
   * @param {*} response 
   * @param {*} normalPayload 
   */
  static mergeNormalBetSelectionWithResponse(selections, response, normalPayload) {
    _.forEach(response, (res, index) => {
      if (res.status === Constants.ACCEPTED) {
        const extraInfo = this.collectExtraInfoByStatus(selections, res.selectionId, Constants.ACCEPTED, normalPayload);
        Object.assign(res.psBetVO, extraInfo);
      } else if (res.status === Constants.PENDING_ACCEPTANCE) {
        const extraInfo = this.collectExtraInfoByStatus(selections, res.selectionId, Constants.PENDING_ACCEPTANCE, normalPayload);
        if (res.psBetVO) {
          // for soccer
          Object.assign(res.psBetVO, extraInfo);
        } else {
          // for other sports except soccer
          Object.assign(res, extraInfo);
        }
      } else {
        const extraInfo = this.collectExtraInfoByStatus(selections, res.selectionId, Constants.PROCESSED_WITH_ERROR, normalPayload);
        Object.assign(res, extraInfo);
      }
    });
    return response;
  }

    /**
   * For render Parlay and teaser accepted bet screen
   * @param {*} selections 
   * @param {*} legs 
   */
  static mergeBetSelectionWithResponse(betItems, response, isParlay, winRiskInfoData) {
    if (isParlay) {
      if (response.status === Constants.ACCEPTED) {
        const result = JSON.parse(JSON.stringify(response))
        const legs = response.parlayBet.legs.map((leg, index) => {
          const bet = betItems.legs.find(
            item => item.eventId === leg.eventId &&
              (
                item.handicap === leg.handicap ||
                item.selection === leg.teamName ||
                (item.leagueId === leg.leagueId && Number(item.odds) === Number(leg.price))
              )
          ) || this.collectExtraInfoAccepted(betItems, leg.eventId, leg, isParlay, index) || {}
          return { ...bet, ...leg }
        })
        result.legs = legs
        return result
      } else if (response.status === Constants.PENDING_ACCEPTANCE) {
        const extraInfo = this.collectExtraInfoPending(betItems, response, isParlay, winRiskInfoData);
        Object.assign(response, extraInfo);
      }
    } else {
      _.forEach(response.teaserBet.legs, (res, index) => {
        const extraInfo = this.collectExtraInfoAccepted(betItems, res.eventId, res, false, index);
        Object.assign(res, extraInfo);
      });
    }
    return response;
  }


  /**
   * For place bet on live event.
   * @param {*} processingQueue 
   * @param {*} betslipStore 
   * @param {*} translate 
   */
  static showToastAfterPendingBetAccepted(processingQueue, betslipStore, translate, onClickToastLink) {
    _.forEach(processingQueue, (bet, index) => {
      const {
        betType,
        teamName,
        periodNum,
        sportGroup,
        sportId,
        //outright
        contestantName,
      } = bet.psBetVO ? bet.psBetVO : bet;

      const {
        wagerId,
        status
      } = bet;

      if (status === Constants.PENDING_ACCEPTANCE) {
        return;
      }

      const isOutright = (betType === BetType.OUTRIGHT || betType === BetType.SPECIALS);
      const betTypeTxt = translate(sportGroup.toLowerCase() + ':' + (_.invert(BetType))[betType]);
      const periodTxt = this.getPeriodDescription(sportId, periodNum, translate);
      let messages = [], toastClass = '', onClickToast = null;
      if (status === Constants.ACCEPTED) {
        messages.push(Constants.TOAST.ACCEPTED_BET_MESSAGE);
        toastClass = Constants.TOAST.TOAST_CLASS_ACTIVE;
        onClickToast = onClickToastLink
      } else if (status === Constants.PROCESSED_WITH_ERROR) {
        messages.push(Constants.TOAST.UNACCEPTED_BET_MESSAGE);
        toastClass = Constants.TOAST.TOAST_CLASS_ERROR;
      }
      messages.push(isOutright ? contestantName : teamName);
      messages.push(isOutright ? '' : (periodTxt + ' - ' + betTypeTxt));
      ToastGeneratorAction.generateToast({messages: messages, className: toastClass, tapOnLinkAction: onClickToast});
      betslipStore.removeProcessingQueueByWagerId(wagerId);
    })
  }

  static isExistingPendingBetItem(bets) {
    const pendingBets = bets.filter(bet => {
      return bet.status === Constants.PENDING_ACCEPTANCE;
    })
    return pendingBets.length > 0;
  }

  static getExistingPendingBetItem(bets) {
    return bets.filter(bet => {
      return bet.status === Constants.PENDING_ACCEPTANCE;
    })
  }

  /**
   * Get more information to show on error screen, waiting screen, success screen after placing normal bet
   * @param {*} selections 
   * @param {*} selectionId 
   * @param {*} status 
   * @param {*} normalPayload 
   */
  static collectExtraInfoByStatus(selections, selectionId, status, normalPayload) {
    const selection = selections.filter(item => {
      return item.selectionId === selectionId;
    });

    let extraInfo = {};
    if (selection.length > 0) {
      extraInfo.oddsId = selection[0].oddsId;
      extraInfo.league = selection[0].league;
      extraInfo.sport = selection[0].sport;
      extraInfo.periodNum = selection[0].periodNum;
      extraInfo.betType = selection[0].betType;
      extraInfo.sportId = selection[0].sportId;
      extraInfo.sportGroup = selection[0].sportGroup;
      extraInfo.handicap = selection[0].handicap;
      extraInfo.baseBall = selection[0].baseBall;
      extraInfo.inplay = selection[0].inplay;
      extraInfo.currentScore = selection[0].currentScore;
      extraInfo.gradingUnits = selection[0].gradingUnit;
      
      if(window.env.betPlacementV4Enabled && status === Constants.ACCEPTED) {
        extraInfo.team1 = selection[0].homeTeam;
        extraInfo.team2 = selection[0].awayTeam;
      }

      if (status === Constants.PENDING_ACCEPTANCE) {
        extraInfo.teamName = selection[0].selection;
        extraInfo.team1 = selection[0].homeTeam;
        extraInfo.team2 = selection[0].awayTeam;
        extraInfo.gradingUnits = selection[0].gradingUnit;
        // get stake from payload
        const payload = normalPayload.selections.filter(selection => {
          return selection.selectionId === selectionId;
        })
        extraInfo.win = this.calculateToWin(payload[0].stake, payload[0].odds, normalPayload.oddsFormat, payload[0].winRiskStake);
        extraInfo.risk = this.calculateToRisk(payload[0].stake, payload[0].odds, normalPayload.oddsFormat, payload[0].winRiskStake);
        if (selection[0].baseBall) {
          extraInfo.pitcher1 = selection[0].pitcherHome;
          extraInfo.pitcher2 = selection[0].pitcherAway;
          extraInfo.pitcher1MustStart = payload[0].pitcher1MustStart;
          extraInfo.pitcher2MustStart = payload[0].pitcher2MustStart;
        }
      }

      if (status === Constants.PROCESSED_WITH_ERROR) {
        extraInfo.teamName = selection[0].selection;
        extraInfo.team1 = selection[0].homeTeam;
        extraInfo.team2 = selection[0].awayTeam;
        extraInfo.odds = selection[0].odds;
        if (selection[0].baseBall) {
          const payload = normalPayload.selections.filter(selection => {
            return selection.selectionId === selectionId;
          })
          extraInfo.pitcherHome = selection[0].pitcherHome;
          extraInfo.pitcherAway = selection[0].pitcherAway;
          extraInfo.pitcher1MustStart = payload[0].pitcher1MustStart;
          extraInfo.pitcher2MustStart = payload[0].pitcher2MustStart;
        }
      }

      if (selection[0].betType === BetType.OUTRIGHT || selection[0].betType === BetType.SPECIALS) {
        extraInfo.contestantName = selection[0].contestantName;
        extraInfo.eventName = selection[0].eventName;
        extraInfo.leagueName = selection[0].leagueName;
        extraInfo.parentEventName = selection[0].parentEventName;
        extraInfo.units = selection[0].unit;
        extraInfo.originalUnit = selection[0].originalUnit
        extraInfo.contest = selection[0].contest
      }

      if (selection[0].betType === BetType.OU
        || selection[0].betType === BetType.HOME_TOTALS
        || selection[0].betType === BetType.AWAY_TOTALS) {
        extraInfo.teamName = selection[0].selection;
      }
    }
    return extraInfo;
  }
  static collectExtraInfoPending(betItems, respone, isParlay, winRiskInfoData) {
    let extraInfo = {};
    if (isParlay) {
      extraInfo.betId = respone.betId;
      extraInfo.toWin = winRiskInfoData.toWin;
      extraInfo.totalStake = winRiskInfoData.totalStake;
      extraInfo.legs = betItems.legs;
      extraInfo.odds = betItems.odds;
    }
    return extraInfo;
  }

  static collectExtraInfoAccepted(betItems, eventId, respone, isParlay, index) {
    const selection = isParlay ? betItems.legs.filter(item => {
      return item.eventId === eventId;
    }) : betItems.legs;

    let extraInfo = {};
    if (selection.length > 0) {
      if (isParlay) {
        extraInfo.legId = selection[0].legId;
        extraInfo.lineId = selection[0].lineId;
        extraInfo.betType = selection[0].betType;
        extraInfo.betTypeDisp = selection[0].betTypeDisp;
        extraInfo.baseBall = selection[0].baseBall;
        extraInfo.sportGroup = selection[0].sportGroup;
        extraInfo.handicap = selection[0].handicap;
        extraInfo.gradingUnits = selection[0].gradingUnit;
        extraInfo.league = selection[0].league;
        extraInfo.leagueId = selection[0].leagueId;
        extraInfo.selection = selection[0].selection;
        extraInfo.selectionId = selection[0].selectionId;
        extraInfo.pitcherHome = selection[0].pitcherHome;
        extraInfo.awayTeam = selection[0].awayTeam;
        extraInfo.homeTeam = selection[0].homeTeam;
        extraInfo.odds = selection[0].odds;
        extraInfo.sport = selection[0].sport;
        extraInfo.periodNum = selection[0].periodNum;
        extraInfo.ticketId = betItems.ticketId;
        extraInfo.currentScore = betItems.currentScore;
        if (selection[0].baseBall) {
          extraInfo.pitcher1 = selection[0].pitcherHome;
          extraInfo.pitcher2 = selection[0].pitcherAway;
          extraInfo.pitcher1MustStart = respone.pitcher1MustStart;
          extraInfo.pitcher2MustStart = respone.pitcher2MustStart;
          extraInfo.ftTeam1Score = respone.ftTeam1Score;
          extraInfo.ftTeam2Score = respone.ftTeam2Score;
        }
      } else {
         // for teaser
         extraInfo.legId = selection[index].legId;
         extraInfo.lineId = selection[index].lineId;
        extraInfo.altTeaser = selection[index].altTeaser;
        extraInfo.awayTeam = selection[index].awayTeam;
        extraInfo.homeTeam = selection[index].homeTeam;
        extraInfo.basedPoint = selection[index].basedPoint;
        extraInfo.basedPointDisp = selection[index].basedPointDisp;
        extraInfo.basedPoint = selection[index].basedPoint;
        extraInfo.point = selection[index].point;
        extraInfo.pointStatus = selection[index].pointStatus;
        extraInfo.selectedPoint = selection[index].selectedPoint;
        extraInfo.selectionType = selection[index].selectionType;
        extraInfo.teaserType = selection[index].teaserType;
      }
    }
    return extraInfo;
  }

  /**
   * Handle error if error occur when place normal bet
   * @param {*} response 
   */
  static handleNormalBetsResponse(normalBetItems, response) {
    let updateItems = [];
    const errors = response.filter(res => {
      return res.errorCode !== null && res.errorCode !== undefined;
    })
    if (errors.length > 0) {
      // if line change we will update information on single betslip for user can resubmit
      // we will get information from jsonString to update
      _.forEach(errors, (error, index) => {
        const uniqueRequestId = error.uniqueRequestId;
        const indexOldBetItem = normalBetItems.findIndex(item => {
          return item.oddsId === error.oddsId;
        })
        const itemNeedUpdate = Object.assign({}, normalBetItems[indexOldBetItem]);
        let infoNeedUpdate = {};
        if (error.jsonString) {
          const json = JSON.parse(error.jsonString);
          const betDetail = json.bets.filter(bet => {
            return bet.uniqueRequestId === uniqueRequestId;
          })
          let status = null;
          if (error.errorCode === Constants.LINE_CHANGED) {
            infoNeedUpdate.lineId = betDetail[0].lineId;
            infoNeedUpdate.maxRiskStake = betDetail[0].maxRiskStake;
            infoNeedUpdate.maxWinStake = betDetail[0].maxWinStake;
            infoNeedUpdate.minRiskStake = betDetail[0].minRiskStake;
            infoNeedUpdate.minWinStake = betDetail[0].minWinStake;
            if (normalBetItems[indexOldBetItem].altLineId) {
              infoNeedUpdate.altLineId = betDetail[0].altLineId;
            }
            if (normalBetItems[indexOldBetItem].odds !== betDetail[0].price) {
              status = Constants.ODDS_CHANGE;
              infoNeedUpdate.odds = betDetail[0].price.toString();
              infoNeedUpdate.oldOdds = normalBetItems[indexOldBetItem].odds;
            }
            infoNeedUpdate.status = status;
            // generate new selection id
            const currentSelectionId = normalBetItems[indexOldBetItem].selectionId.split('|');
            const newSelectionId = this.updateSelectionId(currentSelectionId, infoNeedUpdate);
            infoNeedUpdate.selectionId = newSelectionId;

          } else if (error.errorCode === "ERROR3105") { // Event Offline
            infoNeedUpdate.errorCode = betDetail[0].errorCode;
          }
        } else if (error.errorCode) {
          infoNeedUpdate.errorCode = error.errorCode;
          infoNeedUpdate.errorData = error.errorData;
        }
        updateItems.push(Object.assign(itemNeedUpdate, infoNeedUpdate));
      })
    }
    return updateItems;
  }

  /**
   * Update selection after line change
   * @param {*} selectionId 
   * @param {*} infoNeedUpdate 
   */
  static updateSelectionId(selectionId, infoNeedUpdate) {
    const newSelectionId = [];
    const SELECTION_ID_MAP = {
      lineId: 0,
      altLineId: 1,
      eventId: 2,
      periodNum: 3,
      betType: 4,
      selectionType: 5,
      alt: 6,
      spread: 7,
      teamType: 8
    }
    newSelectionId.push(infoNeedUpdate.lineId);
    newSelectionId.push(infoNeedUpdate.altLineId ? infoNeedUpdate.altLineId : 0);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.eventId]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.periodNum]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.betType]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.selectionType]);
    newSelectionId.push(infoNeedUpdate.altLineId > 0 ? 1 : 0);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.spread]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.teamType]);
    return newSelectionId.join('|');
  }

  static orderNormalBetsResponseByUserSelections(selections, response, UIprops) {
    let data = [];
    _.forEach(selections, (selection, index) => {
      const item = response.filter(item => {
        return item.oddsId === selection.oddsId;
      })
      if (item.length > 0) {
        const tranferObj = UIprops.reduce((result, prop) => {
          if(selection[prop]) {
            result[prop] = selection[prop];
          }
          return result;
        }, {})
        data.push({...item[0], ...tranferObj});
      }
    })
    return data;
  }

  static getOddsFormatBeforeChange(oddsSelections, oddFormat) {
    const selection =  _.get(oddsSelections, '[0]', {})
    return _.get(selection, 'oddsFormat', oddFormat)
  }


  static convertOddsByOddsFormat(oddsValue, currentOddsFormat, newOddsFormat) {
    const standardOdds = this.convertToDecimalOdds(currentOddsFormat, oddsValue);
    let newOdds = 0;
    switch (newOddsFormat) {
      case OddsFormat.American:
        newOdds = this.dec2American(standardOdds)
        break;
      case OddsFormat.HongKong:
        newOdds = this.dec2HK(standardOdds);
        break;
      case OddsFormat.Indonesian:
        newOdds = this.dec2Indo(standardOdds);
        break;
      case OddsFormat.Malay:
        newOdds = this.dec2Malay(standardOdds);
        break;
      default:
        newOdds = standardOdds; // if current odd format is Euro Odds
        break;
    }
    return newOdds;
  }

  static convertToDecimalOdds(oddsFormat, oddsValue) {
    let standardOdds = 0;
    oddsValue = parseFloat(oddsValue);
    switch (oddsFormat) {
      case OddsFormat.American:
        standardOdds = this.american2Dec(oddsValue)
        break;
      case OddsFormat.HongKong:
        standardOdds = this.hk2Dec(oddsValue);
        break;
      case OddsFormat.Indonesian:
        standardOdds = this.id2Dec(oddsValue);
        break;
      case OddsFormat.Malay:
        standardOdds = this.malay2Dec(oddsValue);
        break;
      default:
        standardOdds = oddsValue; // if current odd format is Euro Odds
        break;
    }
    return standardOdds;
  }

  /** CONVERT OTHERS ODDS TO DECIMAL ODDS (EURO ODDS) */
  static american2Dec(amOdds) {
    let convertedPrice;
    convertedPrice = amOdds > 0 ? (amOdds / 100 + 1) : (-100 / amOdds + 1);
    return convertedPrice.toDollar(3, true);
  }

  static hk2Dec(hkOdds) {
    return (hkOdds + 1).toDollar(3, true);
  }

  static malay2Dec(malayOdds) {
    let convertedPrice;
    if (malayOdds > 0) {
      convertedPrice = malayOdds + 1;
    } else {
      convertedPrice = 1 - (1 / malayOdds);
    }
    return convertedPrice.toDollar(3, true);
  }

  static id2Dec(idOdds) {
    let convertedPrice;
    if (idOdds >= 0) {
      convertedPrice = idOdds + 1;
    } else {
      convertedPrice = 1 - (1 / idOdds);
    }
    return convertedPrice.toDollar(3, true);
  }

  /** CONVERT DECIMAL ODDS TO OTHERS  */
  static dec2HK(odds) {
    return (odds - 1).toDollar(3, true);
  }

  static dec2Indo(odds) {
    let convertedPrice;
    if (odds >= 2) {
      convertedPrice = odds - 1;
    } else {
      convertedPrice = 1 / (1 - odds);
    }
    return convertedPrice.toDollar(3, true);
  }

  static dec2Malay(odds) {
    let convertedPrice;
    if (odds <= 2) {
      convertedPrice = odds - 1;
    } else {
      convertedPrice = 1 / (1 - odds);
    }
    return convertedPrice.toDollar(3, true);
  }

  static dec2American(odds) {
    let convertedPrice;
    if (odds > 2) {
      convertedPrice = 100 * (odds - 1);

    } else {
      convertedPrice = -100 / (odds - 1);
    }
    return convertedPrice.toDollar(0, true);
  }

  static getParlayPayloadAfterRemove(parlayBetPayload, legId) {
    const payload = parlayBetPayload.parlayOddsRequest.parlayOddsSelections.filter(selection => {
      return selection.legId !== legId;
    })
    let newPayload = Object.assign({}, parlayBetPayload);
    newPayload.parlayOddsRequest.parlayOddsSelections = payload;
    return newPayload;
  }

  static getOddsIdByLegId(parlayBetPayload, legId) {
    const leg = parlayBetPayload.parlayOddsRequest.parlayOddsSelections.filter(parlayBet => {
      return parlayBet.legId === legId;
    })
    return leg[0].oddsId;
  }

  static getSelectionIdByLegId(parlayBetPayload, legId) {
    const leg = parlayBetPayload.parlayOddsRequest.parlayOddsSelections.filter(parlayBet => {
      return parlayBet.legId === legId;
    })
    return leg[0].selectionId;
  }

  static showRemoveAllConfirmPopUp(translate, callback) {
    PopUpModalAction.openPopUpModal(translate('Are you sure you want to clear all tickets?'), callback);
  }

  static getDefaultStake(isReuseSelection, stake) {
    if (localStorage.perfs) {
      const perfs = JSON.parse(Base64.decode(localStorage.perfs));
      if (perfs.enableDefaultStake) {
        return perfs.defaultStake;
      } else if (isReuseSelection) {
        return stake;
       }
      return null;
    }
    return null;
  }

  /**
   * update selectionId in pitchers cache when line change. Because the selectionId changes.
   */
  static updateSelectionIdInPitchersCache(newSelectionId) {
    // update selectionId in pitchers cache
    const pitchersData = StorageHelper.getBrowsersStorage(BROWSER_KEY.PITCHERS);
    if (pitchersData) {
      const pitchers = JSON.parse(Base64.decode(pitchersData));
      _.forEach(pitchers, (pitcher, index) => {
        const oldId = Object.keys(pitcher)[0];
        if (newSelectionId.slice(newSelectionId.indexOf('|'), newSelectionId.length) === oldId.slice(oldId.indexOf('|'), oldId.length)) {
          const newPitcher = {
            [newSelectionId]: pitcher[oldId]
          }
          pitchers.splice(index, 1);
          pitchers.push(newPitcher);
        }
      })
    }
  }

  static removeItemFromPitchersCacheBySelectionId(selectionId) {
    const pitchersData = StorageHelper.getBrowsersStorage(BROWSER_KEY.PITCHERS);
    if (pitchersData) {
      const pitchers = JSON.parse(Base64.decode(pitchersData));
      _.forEach(pitchers, (pitcher, index) => {
        if (Object.keys(pitcher)[0] === selectionId) {
          pitchers.splice(index, 1);
        }
      })
      if (pitchers.length < 1) {
        this.removePitchersCache();
      } else {
        StorageHelper.saveBrowsersStorage(BROWSER_KEY.PITCHERS, Base64.encode(JSON.stringify(pitchers)))
      }
    }
  }

  static removePitchersCache() {
    StorageHelper.removeBrowsersStorage(BROWSER_KEY.PITCHERS);
  }

  /**
   * Show the number keyboard when user enter the stake.
   * Use this pattern for the browser which does not support 'inputMode' attribute
   */
  static getPatternForKeyPad() {
    let pattern = '[0-9]*';
    if (/iPhone/i.test(navigator.userAgent)) {
      pattern = ''; // pattern="[0-9]*" work well on iPad but shows numeric only keyboard on iPhone. So we will use original keyboard.
    }
    return pattern;
  }

static updateWinRiskOption (teaserTicket, oddsFormat, betslipStore){
  if (oddsFormat !== OddsFormat.AM){
    let winRiskOption = teaserTicket.odds > 0 ? "RISK" :  "WIN";
     betslipStore.changeWinRiskOption(winRiskOption);
  }
}
 
static mergeTeaserSelection(oddsSelections, teaserTicket, betslipStore) {
    const { 
      teaserBetPayload,
      teaserBetItems
    } = betslipStore;
    
   _.forEach(teaserTicket.legs, leg => {
      const legId = leg.legId;
      const legs = JSON.parse(teaserBetPayload.legs);
      const idx = this.getIndexInArrayByNameAndValue(legs, 'legId', legId);
      const selectionId = legs[idx].selectionId;
      const extraInfo = oddsSelections.reduce((filtered, selection) => {
        if (selection.selectionId === selectionId) {
          filtered.push({
            homeTeam: selection.homeTeam,
            awayTeam: selection.awayTeam,
            selectionType: selection.selectionType,
            leagueName: selection.leagueName,
            sportName: selection.sportName,
            sportId: selection.sportId,
            teaserType: selection.teaserType,
            eventId: selection.eventId,
            betLocationTracking: selection.betLocationTracking
          })
        }
        return filtered;
      }, [])
      if (extraInfo.length > 0) {
        Object.assign(leg, extraInfo[0]);
      }
   });
   if (!teaserTicket.maxLegs && !teaserTicket.minLegs) {
      const minMaxLegs = { 
       minLegs: teaserBetItems.minLegs,
       maxLegs: teaserBetItems.maxLegs,
      };
      Object.assign(teaserTicket, minMaxLegs);
   }
   this.updateTeaserSelection(teaserTicket.legs, betslipStore);
   betslipStore.setTeaserBetItems(teaserTicket);
}

/**
 * Get index of element in array by name and value
 * Ex: const arr = [{id: 1, age: 12, name: 'test 1'}, {id: 2, age: 10, name: 'test 2'}]
 * Suppose, we want to get element which has age is 12 then we will call getIndexInArrayByNameAndValue(arr, age, 10)
 * If found will return 1 else -1
 * @param {*} arr 
 * @param {*} idName 
 * @param {*} idValue 
 */
static getIndexInArrayByNameAndValue(arr, idName, idValue) {
  return  _.findIndex(arr, item  => {return item[idName] === idValue });
}


static getTeaserSelectionName(homeTeam, awayTeam, selectionType) {
  let selectionName;
  switch (selectionType) {
    case SelectionType.HOME:
      selectionName = homeTeam;
      break;
    case SelectionType.AWAY:
      selectionName = awayTeam;
      break;
    case SelectionType.UNDER:
      selectionName = 'Under';
      break;
    case SelectionType.OVER:
      selectionName = 'Over';
      break;
    default:
    selectionName = '';
  }
  return selectionName;
}

static getTeaserBetTypeDisplay(translation, selectionType, periodsDescription, sportId, period) {
  let txt = '';
  const periodTxt = Utils.getPeriodName(periodsDescription, sportId , period, true);
  if (selectionType === SelectionType.HOME || selectionType === SelectionType.AWAY) {
    txt = translation('HANDICAP') + ' - ' + periodTxt;
  } else if (selectionType === SelectionType.OVER || selectionType === SelectionType.UNDER) {
    txt = translation('Over') + '/' + translation('Under') + ' - ' + periodTxt;
  }
  return txt;
}

static getMinRiskForTeaser(winRiskOption, minRiskStake, minWinStake, odds) {
  let minRisk = 0;
  switch (winRiskOption) {
    case Constants.WIN_RISK_OPTION.RISK:
      minRisk = minRiskStake;
      break;
    case Constants.WIN_RISK_OPTION.WIN:
      minRisk = minWinStake;
      break;
    default:
      minRisk = parseFloat(odds) > 0 ? minRiskStake : minWinStake;
  }
  return minRisk;
}

static getMaxRiskForTeaser(winRiskOption, maxRiskStake, maxWinStake, odds) {
  let maxRisk = 0;
  switch (winRiskOption) {
    case Constants.WIN_RISK_OPTION.RISK:
      maxRisk = maxRiskStake;
      break;
    case Constants.WIN_RISK_OPTION.WIN:
      maxRisk = maxWinStake;
      break;
    default:
      maxRisk = parseFloat(odds) > 0 ? maxRiskStake : maxWinStake;
  }
  return maxRisk;
}

static buildTeaserType(translate, legs) {
  if (legs.length > 0) {
    return translate(legs[0].teaserType);
  }
  return '';
}

static showAltTeaser(translate, selectionType, point, basedPoint, selectedPoint) {
  basedPoint = basedPoint >= 0 ? '+' + basedPoint : basedPoint;
  point = point > 0 ? '+' + point : point;
  const basedPointDisp = basedPoint + (selectionType === SelectionType.OVER ? '-' : '+') + selectedPoint;
  const message = translate("ALTERNATE_POINT_INFO").replace("{0}", basedPoint).replace("{1}", point).replace("{2}", basedPointDisp);
  PopUpModalAction.openYesPopUpModal(message, function() {
    PopUpModalAction.closePopUpModal();
    const ticketCircle = document.getElementsByClassName('ticket-circle')[0];
      if (ticketCircle) {
        ticketCircle.classList.remove('hide');
      }
  });
}

static updateTeaserSelection(legs, betslipStore) {
    const {
      teaserBetPayload,
      oddsSelections
    } = betslipStore;
    const payloadLegs = JSON.parse(teaserBetPayload.legs);
    _.forEach(legs, leg => {
      if (leg.pointStatus === Constants.TEASER_ERROR.POINT_CHANGE) {
        const indexPayload = BetslipAction.getIndexInArrayByNameAndValue(payloadLegs, 'legId', leg.legId);
      if (indexPayload > -1) {
          const indexSelection = BetslipAction.getIndexInArrayByNameAndValue(oddsSelections, 'selectionId', payloadLegs[indexPayload].selectionId);
          const newSelectionId = leg.lineId + '|' + oddsSelections[indexSelection].oddsId + '|' + oddsSelections[indexSelection].teamType + '|' + leg.point;
          betslipStore.updateTeaserOddSelectionId(indexSelection, newSelectionId);
          betslipStore.updateTeaserPayloadSelectionId(indexPayload, newSelectionId);
          Object.assign(leg, {errorCode: Constants.TEASER_ERROR.SELECTION_POINT_CHANGED});
        }
      }
      if (leg.errorCode === Constants.TEASER_ERROR.POINTS_NO_LONGER_AVAILABLE || leg.errorCode === Constants.TEASER_ERROR.EVENT_NOT_FOUND) {
        Object.assign(leg, {errorCode: Constants.TEASER_ERROR.EVENT_NOT_FOUND});
      }
    })
}

static calculateTeaserMaxPayout(stake, odds, oddsFormat, winRiskOption) {
    if (!stake){
        return 0;
    }
    stake = parseFloat(stake.toString().replaceAll(',', ''));
    odds = parseFloat(odds);
    let  po = 0;
    if (OddsFormat.American === oddsFormat) {
        if (winRiskOption === Constants.WIN_RISK_OPTION.WIN){
            if (odds > 0) {
                po = stake + (stake / odds * 100 );
            } else if (odds < 0) {
                po = stake + (stake * Math.abs(odds) / 100 );
            }
        } else if (winRiskOption === Constants.WIN_RISK_OPTION.RISK){
            if (odds > 0) {
                po = stake + (stake * odds / 100 );
            } else if (odds < 0) {
                po = stake + (stake / Math.abs(odds) * 100 );
            }
        } else {
            po = (Math.abs(odds)/100 + 1) * stake;
        }
    } else {
        if (odds < 0) {
            var isTrue = OddsFormat.Malay === oddsFormat || OddsFormat.Indonesian === oddsFormat;
            po = isTrue ? (stake * Math.abs(odds) +  stake) : stake * 2;
        } else if (odds < 1) {
            po = stake * odds + stake;
        } else {
            if (oddsFormat === 1) {
                po = stake * odds;
            } else {
                po = stake * odds + stake;
            }
        }
    }
    return po;
};

static getSelectionsHasOddsChange(bets) {
  return bets.filter(bet => {
    return [bet.status, bet.legStatus].includes(Constants.ODDS_CHANGE);
  });
}


  /***************************************************************************
   *                             SERVICE INTEGRATION 
   ****************************************************************************/


  /**
   * API to get odd selection information
   * @param {*} selections 
   */
  static async getAllOddsSelection(payload) {
    return await betPlacementService.getAllOddsSelectionInfo(payload).then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  static async updateAllOddsSelection(payload) {
    return await betPlacementService.updateAllOddsSelectionsInfo(payload).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  /**
   * API to call place Bets
   * @param {*} selectionData 
   */
  static async placeNormalBets(payload) {
    const uniqueRequestId = this.generateUUID();
    return await betPlacementService.postPlaceBetAPI(payload, uniqueRequestId).then(response => {
      return response;
    })
      .catch(error => {
        return null;
      });
  }

  static async placeNewNormalBets(payload) {
    const uniqueRequestId = this.generateUUID();
    return await betPlacementService.postPlaceBetAPI(payload, uniqueRequestId).then(response => {
      return response;
    })
      .catch(error => {
        return null;
      });
  }

  static async placeParlayBets(payload) {
    const uniqueRequestId = this.generateUUID();
    return await betPlacementService.postPlaceParlayBetAPI(payload, uniqueRequestId).then(response => {
      return response;
    })
      .catch(error => {
        return null;
      })
  }

  static async updateParlayTicket(params) {
    return await betPlacementService.getParlayUpdateTicket(params).then(response => {
      return response.data;
    }).catch(error => {
      return null;
    })
  }

  static async getCorrelatedSelection(payload) {
    return await betPlacementService.getCorrelatedSelection(payload).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static async getParlayOddsSelection(payload) {
    return await betPlacementService.getParlayOddsSelection(payload).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static async getTeaserOddsSelection(params) {
    return await betPlacementService.getTeaserOddsSelection(params).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static async buyTeaserBetURL(payload, uniqueRequestId) {
    return await betPlacementService.buyTeaserBetURL(payload, uniqueRequestId).then(response => {
      return response.data;
    })
    .catch(e => {
      return null;
    });
  }

  static async updateTeaserTicket(params) {
    return await betPlacementService.updateTeaserTicket(params).then(rs => {
      return rs.data;
    })
    .catch(e => {
      return [];
    });
  }


  static async removeTeaserTicket(params) {
    return await betPlacementService.removeTeaserTicket(params).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static async getParlayUpdateOddsSelection(payload) {
    return await betPlacementService.getParlayUpdateOddsSelection(payload).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static async removeParlayBetSelection(payload, legId) {
    return await betPlacementService.removeParlayBetSelection(payload, legId).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static updatePitcherParlayTicket = async (params) => {
    return await betPlacementService.updatePitcherParlayTicket(params).then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  static callMyBets = async () => {
    return await betPlacementService.callMyBets().then(res => {
      return res.data;
    })
      .catch(e => {
        return null;
      });
  }

  /** Asia Betslip implementation */

  /**
   * API to get odd selection information
   * @param {*} selections 
   */
  static async getAsiaSingleOdds(selectionData) {
    return await betPlacementService.getAsiaSingleOdds(selectionData).then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  /**
   * API to get Outright odd selection information
   * @param {*} selection 
   */
  static async getAsiaOutrightOdds(params) {
    return await betPlacementService.getAsiaOutrightOdds(params).then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  static buildAsiaSingleOddsSelection = (selectionId, oddsId, oddsFormat) => {
    return [
      {
        selectionId: selectionId,
        oddsId: oddsId,
        ot: oddsFormat
      }
    ]
  }

  static buildAsiaSingleBetPayload = (acceptBetterOdds, oddsFormat, selectionItem, stake, pitcher1MustStart, pitcher2MustStart, winRiskOption) => {
    let selection = {
      odds: selectionItem.odds,
      oddsId: selectionItem.oddsId,
      pitcher1MustStart: pitcher1MustStart,
      pitcher2MustStart: pitcher2MustStart,
      selectionId: selectionItem.selectionId,
      stake: BetslipAction.convertStakeToNumber(stake),
      uniqueRequestId: BetslipAction.generateUUID(),
      wagerType: Constants.WAGER_TYPE.NORMAL,
      winRiskStake: winRiskOption,
      betLocationTracking: selectionItem.betLocationTracking
    }

    return {
      acceptBetterOdds: acceptBetterOdds,
      oddsFormat: oddsFormat,
      selections: [selection]
    }
  }

  static buildNewAsiaSingleBetPayload(acceptBetterOdds, oddsFormat, betItems, stakeInputs, winRiskOption) {
    const selections = this.getValidBetForSubmit(betItems, stakeInputs).map(item => {
        return {
          odds: item.odds,
          oddsId: item.oddsId,
          selectionId: item.selectionId,
          stake: BetslipAction.convertStakeToNumber(stakeInputs[item.oddsId].stake),
          uniqueRequestId: BetslipAction.generateUUID(),
          wagerType: item.oddsSelectionsType,
          winRiskStake: winRiskOption,
          betLocationTracking: item.betLocationTracking
        }
      })

    return {
      acceptBetterOdds: acceptBetterOdds,
      oddsFormat: oddsFormat,
      selections: selections
    }
  }

  static buildAsiaOutrightBetPayload = (acceptBetterOdds, oddsFormat, selectionItem, stake, winRiskOption) => {
    let selection = {
      odds: selectionItem.odds,
      pitcher1MustStart: false,
      pitcher2MustStart: false,
      selectionId: selectionItem.selectionId,
      stake: BetslipAction.convertStakeToNumber(stake),
      uniqueRequestId: BetslipAction.generateUUID(),
      wagerType: Constants.WAGER_TYPE.OUTRIGHT,
      winRiskStake: winRiskOption,
      betLocationTracking: selectionItem.betLocationTracking
    }

    return {
      acceptBetterOdds: acceptBetterOdds,
      oddsFormat: oddsFormat,
      selections: [selection]
    }
  }

  static buildAsiaParlayTicketPayload(selectionId, parlayRestriction, oddsFormat, ticketId) {
    return {
      ot: oddsFormat,
      parlayRestriction: parlayRestriction,
      selectionId: selectionId,
      ticketId: ticketId
    }
  }

  static buildParlayBetPayload(ticketId, stake, oddsFormat, acceptBetterOdds, selectedRoundRobinOptions, betLocationTracking) {
    return {
      oddsFormat: oddsFormat,
      acceptBetterOdds: acceptBetterOdds,
      roundRobinOptions: selectedRoundRobinOptions,
      stake: BetslipAction.convertStakeToNumber(stake),
      ticketId: ticketId,
      uniqueRequestId: uuid(),
      betLocationTracking
    }
  }

  static buildParlayUpdateTicketPayload(ticketId, oddsFormat, updateLegs) {
    return {
      ticketId: ticketId,
      ot: oddsFormat,
      parlayLegs: JSON.stringify(updateLegs),
      _: new Date().getTime()
    }
  }

  static formatOddsToDec(odds, format) {
    let decOdds;
    let fromOdds = parseFloat(odds);
    switch (format) {
      case 'HK':
      case OddsFormat.HK:
        decOdds = this.hk2Dec(fromOdds);
        break;
      case 'ID':
      case OddsFormat.ID:
        decOdds = this.id2Dec(fromOdds);
        break;
      case 'MY':
      case OddsFormat.MY:
        decOdds = this.malay2Dec(fromOdds);
        break;
      case 'AM':
      case OddsFormat.AM:
        decOdds = this.american2Dec(fromOdds);
        break;
      default:
        decOdds = fromOdds;
    }
    return decOdds.toDollar(3, true);
  }

  static fromDecToTargetOdds(decOdds, format) {
    let value = decOdds;
    let fromOdds = parseFloat(decOdds);
    switch (format) {
      case 'AM':
      case OddsFormat.AM:
        value = this.dec2American(fromOdds);
        break;
      case 'HK':
      case OddsFormat.HK:
        value = this.dec2HK(fromOdds);
        break;
      case 'ID':
      case OddsFormat.ID:
        value = this.dec2Indo(fromOdds);
        break;
      case 'MY':
      case OddsFormat.MY:
        value = this.dec2Malay(fromOdds);
        break;
      case 'EU':
        return fromOdds;
      default:
        return;
    }

    return value;
  }

  static convertBetPlacementErrorCode(errorCode) {
    let convertedCode
    switch (errorCode) {
      case 'ABOVE_MAX_BET_AMOUNT':
        convertedCode = 'ERROR3103'
        break
      case 'BELOW_MIN_BET_AMOUNT':
        convertedCode = 'ERROR3104'
        break
      default:
        convertedCode = errorCode
    }

    return convertedCode
  }

  static generateSelectionId(selection) {
    let selectionId = [];
    let oldSelectionId = selection.selectionId.split('|');
    selectionId.push(selection.lineId);
    selectionId.push(selection.altLineId ? selection.altLineId : 0);
    selectionId.push(oldSelectionId[2]);
    selectionId.push(oldSelectionId[3]);
    selectionId.push(oldSelectionId[4]);
    selectionId.push(oldSelectionId[5]);
    selectionId.push(selection.altLineId > 0 ? 1 : 0);
    selectionId.push(oldSelectionId[7]);
    selectionId.push(oldSelectionId[8]);

    return selectionId.join('|');
  }

  /**
   * Parlay' odds will be displayed if meet one of following criteria:
   * 1. No Round Robin Option available to select
   * 2. There are more than one Round Robin Option available & user doesn't select any RRO
   * 3. Only Parlay Round Robin Option is selected
   */
  static isDisplayParlayOdds = (availableRROs, selectedRROs) => {
    return availableRROs && availableRROs.length > 0 && (
      availableRROs.length === 1
      || !selectedRROs
      || selectedRROs.length == 0
      || (selectedRROs.length === 1 && selectedRROs.indexOf(RoundRobinOption.PARLAY) > -1)
    )
  }

  static getPeriodDescription(sportId, periodNum, translate, useTag = false) {
    if (periodNum === 0 && sportId !== Constants.HOCKEY_ID) {
      return useTag
        ? <em dir="ltr">{translate('FT')}</em>
        : translate('FT')
    }
    return translate('periods:periods_' + sportId + '_' + periodNum);
  }

   /**
   * Selection is passed from b2b site to iframe. It should be followed the format as bellow:
   * {
   *    eventId: number
   *    period: number
   *    betType: string (SPREAD | MONEYLINE | TOTAL_POINTS | TEAM_TOTAL_POINTS | OUTRIGHT)
   *    altLineId: numer
   *    team: string (HOME | AWAY)
   *    hdp: number
   *    points: number
   *    contestantLineId: number (for outright event)
   *    side: string (OVER | UNDER)
   * }
   * This function used to generate the oddsId base on above info
   */

  static buildSelectionFromIframe = (selection) => {
    const {
      eventId,
      period,
      betType,
      team,
      altLineId,
      hdp,
      points,
      side,
      contestantLineId
    } = selection;

    const isOutright = [
      SimplifiedBetType.SPECIALS, 
      SimplifiedBetType.OUTRIGHT
    ].includes(SimplifiedBetType[betType]);

    const teamType = 0; // to by pass validation line change in backend side
    const lineId = 1;  // to by pass validation line change in backend side

    const alt = altLineId > 0 ? 1 : 0;
    const isTeamTotalPoints = [SimplifiedOriginalBetType.TEAM_TOTAL_POINTS].includes(betType);
    const isTotalPoints = [SimplifiedOriginalBetType.TOTAL_POINTS].includes(betType);

    const bt = isTeamTotalPoints
      ? SimplifiedBetType[`${team}_${betType}`.toUpperCase()]
      : SimplifiedBetType[betType]

    let selectionType = SimplifiedSelectionType[team];
    if (isTeamTotalPoints || isTotalPoints) {
      selectionType = isTeamTotalPoints
        ? SimplifiedSelectionType[`${team}_${side}_${betType}`.toUpperCase()]
        : SimplifiedSelectionType[`${side}_${betType}`.toUpperCase()]
    } else if (isOutright) {
      selectionType = SimplifiedSelectionType[SimplifiedOriginalBetType.OUTRIGHT];
    }

    const spread = isTeamTotalPoints || isTotalPoints 
      ? points
      : hdp;

    const oddsId = isOutright
      ? [eventId, period, bt, selectionType, alt, spread, contestantLineId].join("|")
      : [eventId, period, bt, selectionType, alt, spread].join("|");
    
    return {
      type: isOutright 
        ? Constants.ASIA_BETSLIP_TYPES.OUTRIGHT
        : Constants.ASIA_BETSLIP_TYPES.SINGLE,
      data: {
        id: oddsId,
        selection: [lineId, oddsId, teamType].join('|'),
        isSimplifiedBet: true
      }
    }
  }

  /**
 * Parse selection id is returned from /all-odds-selection services.
 * This function used for selection id which includes altLineId
 */
  static parseSelectionIdWithAltLineId = (selectionId) => {
    const parts = selectionId.split('|');
    if (parts.length === 9) {
      return {
        lineId: parts[0],
        altLineId: parts[1],
        eventId: parts[2],
        period: parts[3],
        betType: parts[4],
        selectionType: parts[5],
        isAlt: parts[6],
        handicap: parts[7],
        teamType: parts[8]
      }
    }
    return {};
  }

  /**
  * Parse selection id is returned from /all-odds-selection services.
  * This function used for selection id which does not include altLineId
  */
  static parseSelectionIdWithoutAltLineId = (selectionId) => {
    const parts = selectionId.split('|');
    if (parts.length === 8) {
      return {
        lineId: parts[0],
        eventId: parts[1],
        period: parts[2],
        betType: parts[3],
        selectionType: parts[4],
        isAlt: parts[5],
        handicap: parts[6],
        teamType: parts[7]
      }
    }
    return {};
  }

  /**
  * Parse selection id is returned from /all-odds-selection services.
  * This function used for selection id which includes contestantLineId
  */
 static parseSelectionIdWithContestantLineId = (selectionId) => {
  const parts = selectionId.split('|');
    if (parts.length === 9) {
      return {
        lineId: parts[0],
        eventId: parts[1],
        period: parts[2],
        betType: parts[3],
        selectionType: parts[4],
        isAlt: parts[5],
        handicap: parts[6],
        contestantLineId: parts[7],
        teamType: parts[8]
      }
    }
    return {}
  }

  static checkSuccessBet = (status) => {
    return status === Constants.PENDING_ACCEPTANCE
      || status === Constants.WAGER_STATUS.CANCELLED
      || status === Constants.WAGER_STATUS.OPEN
      || status === Constants.WAGER_STATUS.ACCEPTED
  }

  static getValidBetForSubmit(betItems, stakeInputs) {
    return betItems.filter(bet => {
      const isSuccessBet = this.checkSuccessBet(bet.status)
      const isInvalidStatus = this.isInValidStatus(bet.status)
      const stake = stakeInputs[bet.oddsId] && BetslipAction.convertStakeToNumber(stakeInputs[bet.oddsId].stake);
      return !isSuccessBet && !isInvalidStatus && !!stake;
    }) || []
  }

  static isAllBetsSuccess(bets) {
    return bets.length && bets.every(bet => this.checkSuccessBet(bet.status))
  }
  
  static getSingleTotalStake(betItems, stakeInputs) {
    let validInputs = {}
    this.getValidBetForSubmit(betItems, stakeInputs).forEach(bet => {
      const inputItem = stakeInputs[bet.oddsId]
      if (inputItem) validInputs[bet.oddsId] = inputItem
    })

    return Object.values(validInputs).reduce(
      (accumulator, item) => {
        return accumulator + Number(!!item.stake && item.stake.replaceAll(',', ''))
      },
      0
    );
  }

  static getSingleTotalRisk(betItems, stakeInputs, winRiskOption, oddsFormat) {
    let validInputs = {}
    this.getValidBetForSubmit(betItems, stakeInputs).forEach(bet => {
      const inputItem = stakeInputs[bet.oddsId]
      if (inputItem) {
        inputItem.odds = bet.odds
        validInputs[bet.oddsId] = inputItem 
      }
    })

    return Object.values(validInputs).reduce(
      (accumulator, item) => {
        
        const stake = Number(!!item.stake && item.stake.replaceAll(',', ''))
        return accumulator + this.calculateToRisk(stake, item.odds, oddsFormat, winRiskOption)
      },
      0
    );
  }

  static getSinglePotentialWin(betItems, stakeInputs, winRiskOption, oddsFormat) {
    let validInputs = {}
    this.getValidBetForSubmit(betItems, stakeInputs).forEach(bet => {
      const inputItem = stakeInputs[bet.oddsId]
      if (inputItem) {
        inputItem.odds = bet.odds
        validInputs[bet.oddsId] = inputItem 
      }
    })

    return Object.values(validInputs).reduce(
      (accumulator, item) => {
        const stake = this.convertStakeToNumber(item.stake)
        return accumulator + Number(item.maxPayout) - this.calculateToRisk(stake, item.odds, oddsFormat, winRiskOption)
      },
      0
    );
  }

  static checkErrorDisplayOnLeg(status) {
    if (!status) return false;
    return !this.checkSuccessBet(status) && ![Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED].includes(status);
  }

  static updateOldOdds(oddValue, betType, oddsFormat, previousOddsFormat) {
    const is1x2 = betType === BetType.THE_1X2;
    let odds = Utils.formatOddsValue(oddValue, oddsFormat);
    if (is1x2) {
       // odds is the same if betType is 1x2 and oddsFormat is EU, HK or MY
      if ([oddsFormat, previousOddsFormat].includes(OddsFormat.AM)) {
        if (previousOddsFormat === OddsFormat.AM) {
          // parse to decimal when previous is AM
          odds = this.convertToDecimalOdds(previousOddsFormat, oddValue);
        } else {
          // when change to AM will parse from decimal odds to AM odds
          odds = Utils.formatOddsValue(this.dec2American(oddValue), oddsFormat);
        }
      }
    } else if (previousOddsFormat !== oddsFormat) {
      odds = this.convertOddsByOddsFormat(oddValue, previousOddsFormat, oddsFormat);
    }
    return odds;
  }



  /**
   * merge selection props into response selection
   * @param {*} response 
   * @param {*} selection 
   * @param {*} props 
   * @returns 
   */
  static mergeSelectionIntoResponse(response, selection, props = []) {
    if(_.isEmpty(response)) return;
    const selectionProp = props.reduce((transferObj, prop) => {
      if (selection[prop]) {
        transferObj[prop] = selection[prop];
      }
      return transferObj;
    }, {});
    return {
      ...response,
      ...selectionProp
    };
  }

  static getReuseSelection = (selection) => {
    const betLocationTracking = get(selection, "betLocationTracking", {});
    return window.env.enableBetLocationTracking ?
      {
        ...selection,
        betLocationTracking: { ...betLocationTracking, reuseSelection: true }
      } : selection;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/BetslipComponent/BetslipAction.js